<template>
  <div :class="['definition-container', id]" :style="getDefinitionStyle()">
    <transition name="fade" mode="out-in">
      <div v-if="!loading" id="container_form_definition" :class="['w3-contanier', type.id, type.modeView, open ? 'open' : '', {'template': isTemplate()}, {'tree': isTree()}]">
        <!-- header for definition name [id] -->
        <div v-if="(type.id === 'search' && fieldsHeader !== '') || ((type.id === 'definition' || type.id === 'template') && (fieldsHeader !== '' || headerLang !== ''))" :class="['definition-title', 'w3-row']">
          <transition name="fade" mode="out-in">
            <span v-if="fieldsHeader !== ''" class="fieldsHeaderTitle" v-text="fieldsHeader" />
            <span v-else-if="headerLang !== ''" class="headerLangTitle" v-text="getLang(headerLang)" />
          </transition>
        </div>

        <!-- for definition type 'definition' -->
        <div
          id="form_definition" class="w3-row" v-bind:class="{'w3-dropdown-content': open,'w3-animate-opacity': open === false && cont > 0}"
        >
          <form v-on:submit.prevent>

            <!-- Carousel presentation (vue-carousel-tmd removed, using simple list) -->
            <div v-if="isCarousel()" class="carousel-fallback">
              <div v-for="(child, index) in definitionContent.requestDefinition" :key="child.id">
                <definition-obj :key="child.id"
                  :id="child.id"
                  :definitionId="id"
                  :reqDef="child"
                  :reqObj="getRequestObjectById(child.id)"
                  :content="definitionContent"
                  :modeView="type.modeView"
                  :validateForm="getCarouselValidateForm(index)"
                  :validateAddForm="validateAddForm"
                  :repeatableGroupId="getRepeatableGroupId(child)"
                  :languageSelected="languageSelected"
                  :definitionContentId="definitionContentId"
                  :definitionContentCode="definitionContentCode"
                  :requestObjectForAddModified="requestObjectForAddModified"
                  :language="language"
                  :visualDefinition="visualDefinition"
                  :authorization="authorization"
                  :type="type"
                  :visuals="visuals"
                  :apiparams="apiparams"
                  :formAddErrors="formAddErrors"
                  :formAddSaved="formAddSaved"
                  :formAddRemoved="formAddRemoved"
                  @refreshDefinition="refreshDefinition"
                  @repeatableGroupModified="modifyDefinitionContentRequestObject"
                  @activateValidatingAddForm="activateValidatingAddForm"
                  @deactivateValidatingAddForm="deactivateValidatingAddForm"
                  @errorAddForm="errorAddForm"
                  @errorModifyForm="errorModifyForm"
                  @formAddSaved="addSaved"
                  @newLanguageSelected="newLanguageSelected"
                  @modifyRepeatibleGroup="modifyDefinitionContentRequestObject"
                  @modifyingAddForm="modifyingAddForm"
                  @removingAddForm="removingAddForm"
                  @conditionalDefinitionChange="conditionalDefinitionChange"
                  @refreshDefinitionContent="refreshDefinitionContent"
                  @waitingProcessInit="waitingProcessInit"
                  @taskLink="taskLink"
                  @editingQuestion="editingQuestion"
                  @callSaveByFieldChange="callSaveByFieldChange"
                />
              </div>
            </div>

            <template v-else-if="isJSONViewer() && jsonViewerObject">
              <json-viewer
                :value="jsonViewerObject"
                :expanded="true"
                :expand-depth="100"
              />
            </template>

            <definition-obj v-else-if="!isTree()" v-for="reqDef in definitionContent.requestDefinition" :key="reqDef.id"
              :id="reqDef.id"
              :definitionId="id"
              :reqDef="reqDef"
              :reqObj="getRequestObjectById(reqDef.id)"
              :content="definitionContent"
              :modeView="type.modeView"
              :validateForm="validateForm"
              :validateAddForm="validateAddForm"
              :repeatableGroupId="getRepeatableGroupId(reqDef)"
              :languageSelected="languageSelected"
              :definitionContentId="definitionContentId"
              :definitionContentCode="definitionContentCode"
              :requestObjectForAddModified="requestObjectForAddModified"
              :language="language"
              :visualDefinition="visualDefinition"
              :authorization="authorization"
              :type="type"
              :visuals="visuals"
              :apiparams="apiparams"
              :formAddErrors="formAddErrors"
              :formAddSaved="formAddSaved"
              :formAddRemoved="formAddRemoved"
              @refreshDefinition="refreshDefinition"
              @repeatableGroupModified="modifyDefinitionContentRequestObject"
              @activateValidatingAddForm="activateValidatingAddForm"
              @deactivateValidatingAddForm="deactivateValidatingAddForm"
              @errorAddForm="errorAddForm"
              @errorModifyForm="errorModifyForm"
              @formAddSaved="addSaved"
              @newLanguageSelected="newLanguageSelected"
              @modifyRepeatibleGroup="modifyDefinitionContentRequestObject"
              @modifyingAddForm="modifyingAddForm"
              @removingAddForm="removingAddForm"
              @conditionalDefinitionChange="conditionalDefinitionChange"
              @refreshDefinitionContent="refreshDefinitionContent"
              @waitingProcessInit="waitingProcessInit"
              @taskLink="taskLink"
              @editingQuestion="editingQuestion"
              @callSaveByFieldChange="callSaveByFieldChange"
            />
          </form>
        </div>

        <!-- for definition type 'template' -->
        <div v-if="isTemplate() && !loading" class="definitionObj template">
          <div class="definition-wrapper text">
            <div class="languageSelectorOrTask">
              <definition-multilanguage
                :definition="getTemplateReqDef('contenthtml')"
                :object="getTemplateReqObj('contenthtml')"
                :languageSelected="languageSelected" :translating="translating" :language="language" :apiparams="apiparams"
                @newLanguageSelected="newLanguageSelected" @copy="launchCopyTemplate"
              />
            </div>
          </div>
          <!-- grapes-js-editor removed: not used in Vue 3 -->
        </div>


        <!-- for definition type 'template' -->
        <div v-if="isTree() && !loading">
          <definition-tree
            :tree="getTree()"
            :language="language"
            :visualDefinition="visualDefinition.definition"
            @clickedText="goToMenu"
          />
        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <!-- save / modify / delete buttons and messages -->
      <action-buttons v-if="!embeddedDefinition && isTypeWithActions && !loading && !isEditingQuestion"
        :id="id"
        :actions="getTypeActions()"
        :definitionContentId="definitionContentId"
        :validating="validateForm.validating"
        :validatingAddForm="validateAddForm.validatingAdd"
        :formErrors="formErrors"
        :formAddErrors="formAddErrors"
        :formModifyErrors="formModifyErrors"
        :formSaved="formSaved"
        :resultSuccessMsg="resultSuccessMsg"
        :formAddSaved="formAddSaved"
        :formSavedError="formSavedError"
        :formDeleted="formDeleted"
        :formConfirmDelete="formConfirmDelete"
        :validatingDelete="validatingDelete"
        :formSavedErrorMsg="formSavedErrorMsg"
        :language="language"
        :authorization="authorization"
        :type="type"
        :visuals="visuals"
        :apiparams="apiparams"
        :hideButtons="hideButtons"
        :menuName="menuName"
        :carouselOptions="carouselOptions"
        :carouselPage="carouselPage"
        :slideCount="slideCount"
        :requestDefinition="definitionContent.requestDefinition"
        :requestObject="definitionContent.requestObject"
        :definitionContent="definitionContent"
        :objectChanged="objectChanged"
        :visualDefinition="visualDefinition"
        :validateForm="validateForm"
        :validateAddForm="validateAddForm"
        :languageSelected="languageSelected"
        :definitionContentCode="definitionContentCode"
        :requestObjectForAddModified="requestObjectForAddModified"
        :formAddRemoved="formAddRemoved"
        :actionButtonTasks="actionButtonTasks"
        @callDelete="callDelete"
        @callCreate="callCreate"
        @callUpdate="callUpdate"
        @popupClose="popupClose"
        @confirmDelete="confirmDelete"
        @cancelDelete="cancelDelete"
        @callPrevCarouselPage="callPrevCarouselPage"
        @callNextCarouselPage="callNextCarouselPage"
        @callPaginationCarouselPage="callPaginationCarouselPage"
        @refreshDefinition="refreshDefinition"
        @repeatableGroupModified="modifyDefinitionContentRequestObject"
        @activateValidatingAddForm="activateValidatingAddForm"
        @deactivateValidatingAddForm="deactivateValidatingAddForm"
        @errorAddForm="errorAddForm"
        @errorModifyForm="errorModifyForm"
        @formAddSaved="addSaved"
        @newLanguageSelected="newLanguageSelected"
        @modifyRepeatibleGroup="modifyDefinitionContentRequestObject"
        @modifyingAddForm="modifyingAddForm"
        @removingAddForm="removingAddForm"
        @conditionalDefinitionChange="conditionalDefinitionChange"
        @refreshDefinitionContent="refreshDefinitionContent"
        @waitingProcessInit="waitingProcessInit"
        @taskLink="taskLink"
        @editingQuestion="editingQuestion"
        @callSaveByFieldChange="callSaveByFieldChange"
      />
    </transition>

  </div>
</template>

<script>
import DefinitionMultilanguage from './item/multilanguage' // comment for 'definition.js' low size
import DefinitionTask from './item/task' // comment for 'definition.js' low size
import DefinitionTree from './item/tree' // comment for 'definition.js' low size
import DefinitionObj from './item/definitionObj'
import ActionButtons from './action'
import transport from 'vue-definition-utils/src/utils/transport'
import * as api from './utils/definitionApi'
import moment from 'moment'
import language from './language'
import Visual from 'vue-definition-utils/src/utils/visual'
import JsonViewer from 'vue-json-viewer'

export default {
  name: 'definition',
  props: {
    type: {
      type: Object
    },
    content: {
      type: Object
    },
    id: {
      type: String
    },
    language: {
      type: Object
    },
    visuals: {
      type: Array
    },
    authorization: {
      type: String
    },
    apiparams: {
      type: Object
    },
    fromPopup: {
      type: Boolean
    },
    fromPopupId: {
      type: String
    },
    saveDefinition: {},
    saveDefinitionTo: {},
    embeddedDefinition: {},
    builderModifyCall: {},
    builderDeleteCall: {},
    showloading: {
      type: Boolean,
      default: false
    },
    onloadfunction: {
      type: String
    },
    loadedstyleclasses: {
      type: String
    },
    sdcontainer: {
      type: String
    },
    menuName: {
      type: String
    },
    taskObject: {
      type: Array
    },
    objectChanged: {
      type: Boolean
    },
    callCreateFromNew: {
      type: Number
    },
    detailParentContentId: {
      type: String
    },
    apiDefinitionId: {
      type: String
    }
  },
  data () {
    return {
      fieldsHeader: '',
      headerLang: '',
      open: false,
      cont: 0,
      loading: false,
      translating: false,
      definitionContent: {},
      definitionContentId: null,
      definitionContentCode: null,
      validateForm: {
        validating: false,
        timeEvent: null
      },
      validateAddForm: {
        repeatableGroupId: null,
        validatingAdd: false,
        timeEventAdd: null
      },
      formErrors: 0,
      formAddErrors: 0,
      formModifyErrors: 0,
      formSaved: false,
      resultSuccessMsg: null,
      formAddSaved: false,
      formSavedError: false,
      formSavedErrorMsg: null,
      formDeleted: false,
      formConfirmDelete: false,
      validatingDelete: false,
      confirmDeleteTimerId: null,
      languageSelected: null,
      previousLanguageKey: null,
      saveTemplate: null,
      savingLanguageTemplate: false,
      copyingTemplateLanguage: null,
      requestObjectForAddModified: {
        ts: null
      },
      visualDefinition: null,
      formAddRemoved: {
        code: null,
        id: null,
        removed: false,
        ts: null
      },
      hideButtons: null,
      editorTexts: {
        addIndividualParamsTitle: this.getLang('addIndividualParamsTitle'),
        addProfessionalParamsTitle: this.getLang('addProfessionalParamsTitle'),
        addIndicatorParamsTitle: this.getLang('addIndicatorParamsTitle'),
        addMeetingParamsTitle: this.getLang('addMeetingParamsTitle'),
        addMinutesParamsTitle: this.getLang('addMinutesParamsTitle'),
        addCertificateParamsTitle: this.getLang('addCertificateParamsTitle'),
        selectText: this.getLang('select')
      },
      carouselOptions: null,
      carouselPage: null,
      carouselValidateForm: [],
      slideCount: null,
      carouselNavigation: null,
      isEditingQuestion: false,
      jsonViewerObject: null,
      actionButtonTasks: []
    }
  },
  components: {
    DefinitionMultilanguage, // comment for 'definition.js' low size
    DefinitionTask, // comment for 'definition.js' low size
    DefinitionTree, // comment for 'definition.js' low size
    DefinitionObj,
    ActionButtons,
    JsonViewer
  },
  beforeMount () {
    this.getDefinitionContent()
  },
  methods: {
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    refreshDefinition (newReqObj, scope) {
      if (newReqObj && scope === 'full') {
        this.definitionContent.requestObject = newReqObj
      } else if (newReqObj) {
        for (var i = 0; i < this.definitionContent.requestObject.length; i++) {
          this.definitionContent.requestObject[i] = transport.methods.changeRequestObject(newReqObj.id, this.definitionContent.requestObject[i], newReqObj)
        }
      }
      this.$emit('refreshDefinition', this.definitionContent.requestObject)

      // header defined by definition
      var languageSelectedKey = null
      if (this.languageSelected) {
        languageSelectedKey = this.languageSelected.key
      }
      this.fieldsHeader = this.visualDefinition.getDefinitionFieldsHeader(this.id, this.definitionContent.requestDefinition, this.definitionContent.requestObject, languageSelectedKey)
      this.$emit('refreshDefinitionTitle', this.fieldsHeader)
    },
    isSaveDefinition () {
      var result = false
      if (this.definitionContent.requestDefinition) {
        result = this.type.id === 'definition' || (this.type.id === 'template' && !this.getTemplateValue('templateurl'))
      }
      return result
    },
    isTemplate () {
      var result = false
      if (this.definitionContent.requestDefinition) {
        result = this.type.id === 'template' && this.getTemplateValue('templateurl')
      }
      return result
    },
    isTree () {
      var result = false
      if (this.definitionContent.requestDefinition) {
        result = this.type.id === 'tree'
      }
      return result
    },
    isJSONViewer () {
      return this.visualDefinition && this.visualDefinition.definition && this.visualDefinition.definition.jsonViewer
    },
    getTree () {
      var result = null
      var treeObject = null

      treeObject = transport.methods.getRequestObjectByAliasName('tree', this.definitionContent.requestObject)
      if (treeObject && treeObject.textValue !== '') {
        result = JSON.parse(treeObject.textValue)
      }

      return result
    },
    goToMenu (text) {
      if (text.data.menuId) {
        var urlObj = {
          name: text.data.menuId
        }
        if (text.data.id) {
          urlObj.params = {
            id: text.data.id
          }
        }
        this.$emit('changeUrl', urlObj)
      }
    },
    callCreate (stayAfterSave, goToAfterSave, confirmText) {
      if (!confirmText) {
        this.doCreate(stayAfterSave, goToAfterSave)
      } else {
        // Dialog
        let options = {
          okText: this.$ml.get('yes').toUpperCase(),
          cancelText: this.$ml.get('no').toUpperCase(),
          customClass: 'sherpaDialog'
        }
        this.$dialog.confirm(confirmText, options)
          .then((dialog) => {
            this.doCreate(stayAfterSave, goToAfterSave)
          })
          .catch(() => {
          })
      }
    },
    doCreate (stayAfterSave, goToAfterSave) {
      if (this.isSaveDefinition()) {
        this.checkForm(stayAfterSave, 'create', goToAfterSave)
      } else if (this.type.id === 'template' || this.type.id === 'workflow') {
        this.previousLanguageKey = this.languageSelected.key
        this.saveTemplate = {
          ts: moment().valueOf(),
          mode: 'create',
          stayAfter: stayAfterSave,
          goToAfterSave: goToAfterSave
        }
      }
    },
    callUpdate (stayAfterUpdate, goToAfterSave, confirmText) {
      if (!confirmText) {
        this.doUpdate(stayAfterUpdate, goToAfterSave)
      } else {
        // Dialog
        let options = {
          okText: this.$ml.get('yes').toUpperCase(),
          cancelText: this.$ml.get('no').toUpperCase(),
          customClass: 'sherpaDialog'
        }
        this.$dialog.confirm(confirmText, options)
          .then((dialog) => {
            this.doUpdate(stayAfterUpdate, goToAfterSave)
          })
          .catch(() => {
          })
      }
    },
    doUpdate (stayAfterUpdate, goToAfterSave) {
      if (this.isSaveDefinition()) {
        this.checkForm(stayAfterUpdate, 'update', goToAfterSave)
      } else if (this.type.id === 'template' || this.type.id === 'workflow') {
        this.previousLanguageKey = this.languageSelected.key
        this.saveTemplate = {
          ts: moment().valueOf(),
          mode: 'update',
          stayAfter: stayAfterUpdate,
          goToAfterSave: goToAfterSave
        }
      }
    },
    callDelete (confirmDelete, confirmText) {
      if (!this.validateForm.validating) {
        this.resetMsgAndErrors()

        if (confirmDelete) {
          if (!confirmText) {
            var self = this
            setTimeout(function () {
              self.formConfirmDelete = true
            }, 300)
            this.startConfirmDeleteTimer()
          } else {
            // Dialog
            let options = {
              okText: this.$ml.get('yes').toUpperCase(),
              cancelText: this.$ml.get('no').toUpperCase(),
              customClass: 'sherpaDialog'
            }
            this.$dialog.confirm(confirmText, options)
              .then((dialog) => {
                this.confirmDelete()
              })
              .catch(() => {
              })
          }
        } else {
          this.deleteToAPI()
        }
      }
    },
    confirmDelete () {
      if (!this.validatingDelete) {
        this.$emit('callAction', 'delete', true)
        this.validatingDelete = true
        this.deleteToAPI()
      }
    },
    cancelDelete () {
      if (!this.validatingDelete) {
        var self = this
        setTimeout(function () {
          self.deactivateConfirmDelete()
        }, 200)
      }
      this.validatingDelete = false
    },
    getRequestObjectById (id) {
      return transport.methods.getRequestObjectById(id, this.definitionContent.requestObject)
    },
    getDefinitionContent (forceCall) {
      // this.loading = true

      // new modeView lookup if no actions
      if (this.type && this.type.id === 'definition' && !this.type.actions) {
        this.type.modeView = 'lookup'
      }

      // new Visuals
      this.visualDefinition = new Visual(this.visuals, this.id)
      if (this.visualDefinition && this.visualDefinition.definition) {
        this.hideButtons = this.visualDefinition.definition.hideButtons
      }

      // check if requestDefinition is null
      if ((!this.content.requestDefinition || forceCall) && this.type.endpoint) {
        // remove url query param
        this.$emit('removeUrlQueryParam')

        this.$emit('definitionloading')

        // load new definition
        var dataObj = { }
        if (forceCall) {
          dataObj.id = this.definitionContentId
        } else if (this.isJSONViewer()) {
          dataObj.id = this.apiDefinitionId
        }

        api.call({domainEndpoint: this.type.domainEndpoint, url: this.type.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: dataObj})
          .then(resp => {
            if (this.isJSONViewer()) {
              this.jsonViewerObject = resp
              this.fieldsHeader = this.visualDefinition.getJsonFieldsHeader(this.jsonViewerObject, this.apiDefinitionId)
              this.$emit('refreshDefinitionTitle', this.fieldsHeader)
              this.definitionLoaded()
            } else {
              // all OK
              if (resp.requestResult) {
                this.setDefinitionContent(resp)
              // KO
              } else {
                this.$emit('definitionerror', {response: {status: 500}}, resp.requestResultError, this.$el)
                this.$emit('formDataActionCalled', false)
              }
            }
          })
          .catch(err => {
            this.$emit('definitionerror', err, {requestErrorType: 'SYSTEM', requestErrorMsg: this.language.error500header}, this.$el)
          })
      // else we get the content past by parent
      } else {
        this.setDefinitionContent(this.content)
      }
    },
    isCarousel () {
      return this.visualDefinition.definition && this.visualDefinition.definition.carouselOptions !== undefined && this.visualDefinition.definition.carouselOptions !== null
    },
    carouselValidationFunction () {
      var slidesPerPage = this.carouselOptions.perPage
      if (!slidesPerPage) {
        slidesPerPage = 2
      }

      var initialChildIndex = (this.carouselPage * slidesPerPage) + slidesPerPage - 1
      var endChildIndex = initialChildIndex + slidesPerPage - 1

      var validationReqDefs = []
      var validationReqObjs = []
      var i = initialChildIndex
      for (i; i <= endChildIndex; i++) {
        validationReqDefs.push(this.definitionContent.requestDefinition[i])
        validationReqObjs.push(this.getRequestObjectById(this.definitionContent.requestDefinition[i].id))
      }

      // carousel validation refresh
      var newCarouselValidateForm = []
      for (var j = 0; j < this.definitionContent.requestDefinition.length; j++) {
        if (j >= initialChildIndex && j <= endChildIndex) {
          newCarouselValidateForm.push({
            validating: true,
            timeEvent: moment().valueOf()
          })
        } else {
          newCarouselValidateForm.push({
            validating: false,
            timeEvent: moment().valueOf()
          })
        }
      }
      this.carouselValidateForm = newCarouselValidateForm

      var errors = transport.methods.validateForm(this.type.modeView, validationReqDefs, validationReqObjs)
      var formErrors = errors.errorsNumber

      this.$nextTick(() => {
        if (formErrors > 0) {
          for (var j = 0; j < this.carouselValidateForm.length; j++) {
            if (j >= initialChildIndex && j <= endChildIndex) {
              this.carouselValidateForm[j].validating = false
              this.carouselValidateForm[j].timeEvent = null
            }
          }
        }
      })

      return (formErrors === 0)
    },
    getCarouselValidateForm (index) {
      return this.carouselValidateForm[index]
    },
    navigationClick (direction, validation) {
      this.getCarouselAction('navigation', direction, validation)
    },
    paginationClick (page, validation) {
      this.getCarouselAction('pagination', page, validation)
    },
    pageChange (page) {
      this.getCarouselAction('pageChange', page)
    },
    getCarouselAction (action, actionData, validation) {
      var result = {
        id: this.id,
        action: action,
        fromPage: this.carouselPage,
        actionData: {}
      }

      if (actionData !== undefined && actionData !== null) {
        if (action === 'navigation') {
          result.actionData.direction = actionData
        } else if (action === 'pagination' || action === 'pageChange') {
          result.actionData.page = actionData
          if (action === 'pageChange') {
            this.carouselPage = actionData
          }
        }

        if (action !== 'pageChange') {
          result.actionData.validation = validation
        }
      }

      this.$emit('definitioncarouselaction', result)

      return result
    },
    callPrevCarouselPage () {
      this.carouselNavigation = 'backward'
      this.$nextTick(() => {
        this.carouselNavigation = null
      })
    },
    callNextCarouselPage () {
      this.carouselNavigation = 'forward'
      this.$nextTick(() => {
        this.carouselNavigation = null
      })
    },
    callPaginationCarouselPage (page) {
      this.carouselOptions.navigateTo = -1
      this.$nextTick(() => {
        this.carouselOptions.navigateTo = page
      })
    },
    slideCountEv (slideCount) {
      this.slideCount = slideCount
    },
    setContentId () {
      // get definition type id value
      var requestObjectId = transport.methods.getRequestObjectById(
        transport.methods.getAliasTypeId(this.definitionContent.requestDefinition),
        this.definitionContent.requestObject
      )
      if (requestObjectId) {
        this.definitionContentId = requestObjectId.textValue
      } else if (this.fromPopup) {
        this.definitionContentId = this.fromPopupId
      }
      if (!this.definitionContentId) {
        this.definitionContentId = this.apiDefinitionId
      }
    },
    setContentCode () {
      // get definition type code value
      var requestObjectCode = transport.methods.getRequestObjectById(
        transport.methods.getAliasTypeCode(this.definitionContent.requestDefinition, false),
        this.definitionContent.requestObject
      )
      if (requestObjectCode) {
        this.definitionContentCode = requestObjectCode.textValue
      } else {
        this.definitionContentCode = null
      }
    },
    setDefinitionContent (content) {
      this.definitionContent = content
      if (this.definitionContent.requestObject === null && this.definitionContent.requestDefinition) {
        this.definitionContent.requestObject = transport.methods.getEmptyRequestObject(this.definitionContent.requestDefinition)
      }

      this.setContentId()
      this.setContentCode()

      this.actionButtonTasks = []
      this.addActionButtonTasks(this.definitionContent.requestDefinition)

      // definition loaded (wait if is setted 'template' (with 'templateurl') or 'workflow')
      this.loading = false
      // Defer the callback to be executed after the next DOM update cycle.
      // Use it immediately after you’ve changed some data to wait for the DOM update.
      this.$nextTick(() => {
        if (
          this.type.id === 'definition' ||
          this.type.id === 'search' ||
          // (this.type.id === 'template' && !this.getTemplateValue('templateurl')) ||
          this.type.id === 'template' ||
          this.type.id === 'tree'
        ) {
          this.definitionLoaded()
        }
      })

      // header defined by definition
      var languageKey = null
      if (this.languageSelected) {
        languageKey = this.languageSelected.key
      }

      this.fieldsHeader = this.visualDefinition.getDefinitionFieldsHeader(this.id, this.definitionContent.requestDefinition, this.definitionContent.requestObject, languageKey)
      this.$emit('refreshDefinitionTitle', this.fieldsHeader)

      // header defined statically
      this.headerLang = this.visualDefinition.getDefinitionHeaderLang()

      // Carousel options
      if (this.isCarousel()) {
        this.carouselOptions = this.visualDefinition.definition.carouselOptions
        this.carouselPage = this.carouselOptions.navigateTo
        if (!this.carouselPage) {
          this.carouselPage = 0
        }
        for (var i = 0; i < this.definitionContent.requestDefinition.children.length; i++) {
          this.carouselValidateForm.push({
            validating: false,
            timeEvent: null
          })
        }
      }
    },
    addActionButtonTasks (requestDefinition) {
      if (requestDefinition) {
          requestDefinition.forEach(reqDef => {
          if (this.isClass(reqDef, 'action-button-task')) {
            this.actionButtonTasks.push(reqDef)
          }
          this.addActionButtonTasks(reqDef.children)
        })
      }
    },
    isClass (reqDef, classStr) {
      return this.isInClassString(classStr, this.getDefinitionClass(reqDef))
    },
    getDefinitionClass (reqDef) {
      var definition = this.visualDefinition.getDefinitionFields(reqDef)
      return definition.class
    },
    isInClassString (classStr, allClasses) {
      var result = false
      if (allClasses) {
        var classes = allClasses.split(' ')
        if (classes && classes.length > 0) {
          for (var i = 0; i < classes.length && !result; i++) {
            result = (classes[i] === classStr)
          }
        }
      }
      return result
    },
    checkForm (stay, action, goTo, code) {
      if (!this.validateForm.validating) {
        this.resetMsgAndErrors()
        // change validateForm / watcher waiting...
        this.activateValidatingForm()
        var self = this
        setTimeout(function () {
          var errors = transport.methods.validateForm(self.type.modeView, self.definitionContent.requestDefinition, self.definitionContent.requestObject)
          self.formErrors = errors.errorsNumber
          if (self.formErrors === 0) {
            // No errors on fields. Let's save/update form data.
            if (action === 'create') {
              self.$emit('callAction', 'create', true)
              self.createToAPI(stay, goTo)
            } else if (action === 'update') {
              self.$emit('callAction', 'create', true)
              self.updateToAPI(stay, goTo, code)
            } else if (action === 'none') {
              self.deactivateValidatingForm()
            }

          // Errors on fields.
          } else {
            setTimeout(function () {
              self.deactivateValidatingForm()
              self.$emit('validatingFormError')
            }, 100)
          }
        }, 200)
      }
    },
    resetMsgAndErrors () {
      setTimeout(() => {
        this.formErrors = 0
        this.formAddErrors = 0
        this.formModifyErrors = 0
        this.formSaved = false
        this.formDeleted = false
        this.resultSuccessMsg = null
        this.formAddSaved = false
        this.formSavedError = false
        this.formSavedErrorMsg = null
      }, 3000)
    },
    apiError (response, status, requestResultError) {
      this.validateForm = {
        validating: false,
        timeEvent: moment().valueOf()
      }
      this.formSavedError = true
      if (response) {
        if (response.requestResultError) {
          if (response.requestResultError.requestErrorMsg) {
            this.formSavedErrorMsg = response.requestResultError.requestErrorMsg
          } else if (response.requestResultError.requestCause) {
            this.formSavedErrorMsg = response.requestResultError.requestCause
          }
        }
      } else {
        this.formSavedErrorMsg = this.getLang('error500header')
      }
      this.$emit('validatingFormError')
      this.$emit('definitionerror', status, requestResultError, this.$el)
    },
    activateValidatingForm () {
      this.validateForm = {
        validating: true,
        timeEvent: moment().valueOf()
      }
    },
    deactivateValidatingForm () {
      this.validateForm = {
        validating: false,
        timeEvent: moment().valueOf()
      }
    },
    activateValidatingAddForm (id, code) {
      this.resetMsgAndErrors()
      this.validateAddForm = {
        repeatableGroupId: id,
        validatingAdd: true,
        timeEventAdd: moment().valueOf()
      }
      this.$emit('modifyingAddForm')
    },
    deactivateValidatingAddForm () {
      this.validateAddForm = {
        repeatableGroupId: null,
        validatingAdd: false,
        timeEventAdd: moment().valueOf()
      }
    },
    deactivateConfirmDelete () {
      this.resetMsgAndErrors()
      this.deactivateValidatingForm()
      this.formConfirmDelete = false
    },
    startConfirmDeleteTimer () {
      if (this.confirmDeleteTimerId) {
        clearTimeout(this.confirmDeleteTimerId)
      }
      var self = this
      this.confirmDeleteTimerId = setTimeout(function () {
        if (self.formConfirmDelete && !self.validatingDelete) {
          self.deactivateConfirmDelete()
        }
      }, 10000)
    },
    getOkSaveMessage (okSaveMessage) {
      if (this.visualDefinition && this.visualDefinition.definition && this.visualDefinition.definition.okMessageTxt) {
        return this.visualDefinition.definition.okMessageTxt
      } else {
        return okSaveMessage
      }
    },
    createToAPI (stay, goTo) {
      api.call({domainEndpoint: this.type.domainEndpoint, url: this.type.actions.create.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, requestObject: this.definitionContent.requestObject }})
        .then(resp => {
          if (resp.requestResult) {
            this.formSaved = true
            this.resultSuccessMsg = resp.requestResultSuccess

            if (stay) {
              this.$emit('definitionsaved', this.definitionContent.requestObject, resp, this.getOkSaveMessage(this.getLang('okSaveMessage')))
              this.$emit('formDataActionCalled', stay)

              // save and continue edit
              if (this.type.actions.create.callback && this.type.actions.create.callback.success) {
                if (this.type.actions.create.callback.success !== this.id) {
                  this.$emit('changeUrl', {name: this.type.actions.create.callback.success, params: { id: resp.requestObjectId }})
                } else {
                  this.getDefinitionContent(true)
                }
              // save and new one
              } else {
                this.definitionContent.requestObject = transport.methods.getEmptyRequestObject(this.definitionContent.requestDefinition)
              }
              this.resetMsgAndErrors()
              this.deactivateValidatingForm()
              this.$emit('callAction', 'create', false)
            } else {
              this.$emit('definitionsaved', this.definitionContent.requestObject, resp, this.getOkSaveMessage(this.getLang('okSaveMessage')))
              this.$emit('formDataActionCalled', stay)

              if (goTo) {
                this.$emit('changeUrl', goTo)
              } else {
                if (this.fromPopup) {
                  this.$emit('popupClose')
                } else {
                  this.$emit('closeDetail')
                }
              }
            }
          } else {
            this.apiError(resp, {response: {status: 500}}, resp.requestResultError)
            if (this.type.actions.create.callback && this.type.actions.create.callback.error) {
              if (this.type.actions.create.callback.error !== this.id) {
                this.$emit('changeUrl', {name: this.type.actions.create.callback.error})
              } else {
                this.getDefinitionContent(true)
              }
            }
          }
        })
        .catch(err => {
          this.resetMsgAndErrors()
          this.deactivateValidatingForm()
          this.apiError(null, err, {requestErrorType: 'SYSTEM', requestErrorMsg: this.language.error500header})
        })
    },
    updateToAPI (stay, goTo, code) {
      if (this.definitionContentId) {
        var apiCode = this.definitionContentCode
        if (code !== undefined) {
          apiCode = code
        }

        api.call({domainEndpoint: this.type.domainEndpoint, url: this.type.actions.update.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: apiCode, requestObject: this.definitionContent.requestObject }})
          .then(resp => {
            if (resp.requestResult) {
              this.formSaved = true
              this.resultSuccessMsg = resp.requestResultSuccess

              if (stay) {
                this.$emit('definitionupdated', this.definitionContent.requestObject, resp)
                this.$emit('formDataActionCalled', stay)
                this.resetMsgAndErrors()
                this.deactivateValidatingForm()

                if (goTo && goTo === 'refresh') {
                  // 'true' to force definition call
                  this.getDefinitionContent(true)
                } else if (this.type.actions.update.callback && this.type.actions.update.callback.success) {
                  if (this.type.actions.update.callback.success !== this.id) {
                    this.$emit('changeUrl', {name: this.type.actions.update.callback.success, params: { id: this.getParamId() }})
                  } else {
                    this.getDefinitionContent(true)
                  }
                }
              } else {
                this.$emit('definitionupdated', this.definitionContent.requestObject, resp)
                this.$emit('formDataActionCalled', stay)

                if (goTo) {
                  this.$emit('changeUrl', goTo)
                } else if (this.type.actions.update.callback && this.type.actions.update.callback.success) {
                  if (this.type.actions.update.callback.success !== this.id) {
                    this.$emit('changeUrl', {name: this.type.actions.update.callback.success, params: { id: resp.requestObjectId }})
                  } else {
                    this.getDefinitionContent()
                  }
                } else {
                  if (this.fromPopup) {
                    this.$emit('popupClose')
                  } else {
                    this.$emit('closeDetail')
                  }
                }
              }
            } else {
              this.apiError(resp, {response: {status: 500}}, resp.requestResultError)
              if (this.type.actions.update.callback && this.type.actions.update.callback.error) {
                if (this.type.actions.update.callback.error !== this.id) {
                  this.$emit('changeUrl', {name: this.type.actions.update.callback.error, params: { id: resp.requestObjectId }})
                } else {
                  this.getDefinitionContent(true)
                }
              }
            }
          })
          .catch(err => {
            this.resetMsgAndErrors()
            this.deactivateValidatingForm()
            this.apiError(null, err, {requestErrorType: 'SYSTEM', requestErrorMsg: this.language.error500header})
          })
      } else {
        this.resetMsgAndErrors()
        this.deactivateValidatingForm()
      }
    },
    deleteToAPI (code, id) {
      // delete repeatable element from no persisted group repeatable element
      if (!this.type.actions.delete && code !== undefined) {
        this.formAddRemoved = {
          code: code,
          id: id,
          removed: true,
          ts: moment().valueOf()
        }
      // delete repeatable element from persisted group repeatable element
      // or all generic element
      } else if (this.definitionContentId) {
        var apiCode = this.definitionContentCode
        if (code !== undefined) {
          apiCode = code
          // repeatable element delete: show loading on the bottom action buttons
          // (same feedback as save/modify) while the delete request is in flight
          this.activateValidatingForm()
        }

        api.call({domainEndpoint: this.type.domainEndpoint, url: this.type.actions.delete.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: apiCode, requestObject: this.definitionContent.requestObject }})
          .then(resp => {
            this.formConfirmDelete = false
            if (resp.requestResult) {
              this.formDeleted = true
              if (code) {
                // repeatable element removed: stop the bottom-button loading on response
                this.deactivateValidatingForm()
                this.formAddRemoved = {
                  code: code,
                  id: id,
                  removed: true,
                  ts: moment().valueOf()
                }
                this.$emit('formDataActionCalled', true)
              } else {
                if (this.fromPopup) {
                  this.$emit('popupClose')
                } else {
                  // this.$emit('closeDetail')
                  this.$emit('definitiondeleted', this.definitionContent.requestObject, resp)
                }
              }

              // delete from repeatable element: refreshContent
              if (code) {
                this.resetMsgAndErrors()
                this.getDefinitionContent(true)
              } else {
                if (this.type.actions.delete.callback && this.type.actions.delete.callback.success) {
                  if (this.type.actions.delete.callback.success !== this.id) {
                    this.$emit('formDataActionCalled', false)
                    this.$emit('changeUrl', {name: this.type.actions.delete.callback.success, params: { id: this.getParamId() }})
                  } else {
                    this.$emit('formDataActionCalled', true)
                    this.getDefinitionContent(true)
                    this.resetMsgAndErrors()
                  }
                }
              }
            } else {
              this.apiError(resp, {response: {status: 500}}, resp.requestResultError)
              if (this.type.actions.delete.callback && this.type.actions.delete.callback.error) {
                if (this.type.actions.delete.callback.error !== this.id) {
                  this.$emit('changeUrl', {name: this.type.actions.delete.callback.error, params: { id: this.getParamId() }})
                } else {
                  this.getDefinitionContent(true)
                }
              } else {
                if (code) {
                  this.formAddRemoved = {
                    code: code,
                    id: id,
                    removed: false,
                    ts: moment().valueOf()
                  }
                }
              }
              this.$emit('definitiondeleted', this.definitionContent.requestObject, resp)
            }
          })
          .catch(err => {
            this.resetMsgAndErrors()
            this.deactivateValidatingForm()
            this.apiError(null, err, {requestErrorType: 'SYSTEM', requestErrorMsg: this.language.error500header})
          })
      } else {
        this.resetMsgAndErrors()
        this.deactivateValidatingForm()
        this.formConfirmDelete = false
      }
    },
    getParamId () {
      let result
      if (this.detailParentContentId) {
        result = this.detailParentContentId
      } else {
        result = this.definitionContentId
      }
      return result
    },
    getRepeatableGroupId (reqDef) {
      var repeatableGroupId = null
      if (transport.methods.isRepeatableGroup(reqDef)) {
        repeatableGroupId = reqDef.id
      }
      return repeatableGroupId
    },
    isRepeatableGroup (reqDef) {
      return transport.methods.isRepeatableGroup(reqDef)
    },
    errorAddForm (formAddErrors) {
      this.formAddErrors = formAddErrors
    },
    errorModifyForm (formModifyErrors) {
      this.formModifyErrors = formModifyErrors
      if (this.formModifyErrors === 0) {
        this.deactivateValidatingForm()
      }
    },
    addSaved (code) {
      this.formAddSaved = true
      if (this.type.actions.update) {
        this.checkForm(true, 'update', 'refresh', code)
      } else {
        this.refreshDefinition(null)
        var self = this
        setTimeout(function () {
          self.formAddSaved = false
        }, 3000)
      }
    },
    modifyDefinitionContentRequestObject (object, callUpdate, code) {
      if (object) {
        for (var i = 0; i < this.definitionContent.requestObject.length; i++) {
          this.definitionContent.requestObject[i] = transport.methods.modifyRequestObject(this.definitionContent.requestObject[i], object)
        }

        if (callUpdate && this.type.actions.update) {
          this.checkForm(true, 'update', 'refresh', code)
        }
      }
      this.deactivateValidatingAddForm()
      this.$emit('refreshDefinition', object)
    },
    modifyingAddForm (code) {
      this.activateValidatingAddForm(null, code)
    },
    removingAddForm (code, id) {
      this.deleteToAPI(code, id)
    },
    newLanguageSelected (language) {
      if (this.languageSelected) {
        this.previousLanguageKey = this.languageSelected.key
      }
      this.languageSelected = language
      var languageSelectedKey = null
      if (this.languageSelected) {
        languageSelectedKey = this.languageSelected.key
      }
      this.fieldsHeader = this.visualDefinition.getDefinitionFieldsHeader(this.id, this.definitionContent.requestDefinition, this.definitionContent.requestObject, languageSelectedKey)
      this.$emit('refreshDefinitionTitle', this.fieldsHeader)

      // Editor: call save for get language html and content
      if (this.isTemplate()) {
        this.saveTemplate = {
          ts: moment().valueOf(),
          mode: 'language',
          stayAfter: null,
          goToAfterSave: null
        }
      }
    },
    conditionalDefinitionChange (conditionalFieldId, newReqObj) {
      transport.methods.changeConditionalObjects(this.definitionContent.requestObject, conditionalFieldId, newReqObj)
    },
    popupClose () {
      this.resultSuccessMsg = null
    },
    definitionLoaded () {
      this.$emit('definitionloaded', this.definitionContent, this.onloadfunction, this.loadedstyleclasses, this.sdcontainer)
    },
    editorSave (template, html) {
      var contentObj = this.getContentObjectWithEnd('metadata')
      var contentHtmlObj = this.getContentObjectWithEnd('html')

      // not equals languages = language change
      if (this.previousLanguageKey !== this.languageSelected.key) {
        this.savingLanguageTemplate = true
      }

      // save template before language change
      if (this.savingLanguageTemplate) {
        transport.methods.setLanguageValue(contentObj, template, this.previousLanguageKey)
        transport.methods.setLanguageValue(contentHtmlObj, html, this.previousLanguageKey)

        var self = this
        setTimeout(function () {
          self.savingLanguageTemplate = false
          if (this.languageSelected) {
            this.previousLanguageKey = this.languageSelected.key
          }
        }, 500)

      // save template before copy template to other languages
      } else if (this.copyingTemplateLanguage) {
        transport.methods.setLanguageValue(contentObj, template, this.languageSelected.key)
        transport.methods.setLanguageValue(contentHtmlObj, html, this.languageSelected.key)

        this.copyTemplate()

      // call save template service
      } else {
        transport.methods.setLanguageValue(contentObj, template, this.languageSelected.key)
        transport.methods.setLanguageValue(contentHtmlObj, html, this.languageSelected.key)

        if (this.saveTemplate.mode === 'create') {
          this.checkForm(this.saveTemplate.stayAfter, 'create', this.saveTemplate.goToAfterSave)
        } else if (this.saveTemplate.mode === 'update') {
          this.checkForm(this.saveTemplate.stayAfter, 'update', this.saveTemplate.goToAfterSave)
        }
      }
    },
    getTemplateValue (name) {
      var result
      var namePreffix = 'apptmpl_template_'

      var definition = transport.methods.getRequestDefinitionById(namePreffix + name, this.definitionContent.requestDefinition)

      result = transport.methods.getObjectTextValue(
        this.visualDefinition.definition,
        definition,
        this.getRequestObjectById(namePreffix + name),
        null
      )
      if (result === '') {
        if (name === 'templateurl' || name === 'contentmetadata') {
          result = null
        } else if (name === 'title' || name === 'id') {
          result = ''
        }
      } else {
        if (name === 'created') {
          var date = transport.methods.getDate(result, definition)
          result = date.getTime()
        } else if (name === 'contentmetadata') {
          result = JSON.parse(result)
        }
      }

      return result
    },
    getTemplateDomains () {
      var result = []
      if (!this.isMeetingTemplate()) {
        if (this.getTemplateDefinition('individualformvars')) {
          result.push(
            {
              id: 'individual',
              title: 'addIndividualParamsTitle',
              keys: this.getTemplateDomain('individualformvars')
            }
          )
        }
        if (this.getTemplateDefinition('professionalformvars')) {
          result.push(
            {
              id: 'professional',
              title: 'addProfessionalParamsTitle',
              keys: this.getTemplateDomain('professionalformvars')
            }
          )
        }
        if (this.getTemplateDefinition('individualindicatorvars')) {
          result.push(
            {
              id: 'indicator',
              title: 'addIndicatorParamsTitle',
              keys: this.getTemplateDomain('individualindicatorvars')
            }
          )
        }
      } else {
        result.push(
          {
            id: 'meeting',
            title: 'addMeetingParamsTitle',
            keys: this.getTemplateDomain('meetingvars')
          }
        )
        result.push(
          {
            id: 'minutes',
            title: 'addMinutesParamsTitle',
            keys: this.getTemplateDomain('minutesvars')
          }
        )
        result.push(
          {
            id: 'certificate',
            title: 'addCertificateParamsTitle',
            keys: this.getTemplateDomain('certificatevars')
          }
        )
      }
      return result
    },
    getTemplateDefinition (name) {
      var namePreffix = 'apptmpl_template_'
      return transport.methods.getRequestDefinitionById(namePreffix + name, this.definitionContent.requestDefinition)
    },
    getTemplateDomain (name) {
      var result
      var definition = this.getTemplateDefinition(name)

      if (definition) {
        result = definition.validation.domain
      } else {
        result = null
      }

      return result
    },
    isMeetingTemplate () {
      return this.isTemplate() && (this.id.endsWith('certificate-template') || this.id.endsWith('minutes-template') || this.id.endsWith('announcement-template'))
    },
    getAliasNameWithEnd (definition, suffix) {
      var result

      result = null
      if (definition) {
        for (var i = 0; i < definition.length && !result; i++) {
          var reqDef = definition[i]
          if (reqDef && reqDef.id && reqDef.id.endsWith(suffix)) {
            result = reqDef.id
          } else {
            result = this.getAliasNameWithEnd(reqDef.children, suffix)
          }
        }
      }

      return result
    },
    getContentObjectWithEnd (suffix) {
      return this.getRequestObjectById(this.getAliasNameWithEnd(this.definitionContent.requestDefinition, suffix))
    },
    getContentValue () {
      var result

      result = transport.methods.getLanguageValue(this.getContentObjectWithEnd('metadata'), this.languageSelected.key)

      if (result === '') {
        result = null
      } else {
        result = JSON.parse(result)
      }
      return result
    },
    getTypeValue () {
      var result = ''
      if (this.id.indexOf('email') > -1) {
        result = 'newsletter'
      } else if (this.id.indexOf('landing') > -1) {
        result = 'webpage'
      } else {
        result = 'webpage'
      }
      return result
    },
    getTemplateReqDef (name) {
      var namePreffix = 'apptmpl_template_'
      return transport.methods.getRequestDefinitionById(namePreffix + name, this.definitionContent.requestDefinition)
    },
    getTemplateReqObj (name) {
      var namePreffix = 'apptmpl_template_'
      return transport.methods.getRequestObjectById(namePreffix + name, this.definitionContent.requestObject)
    },
    launchCopyTemplate (fromLanguage) {
      this.copyingTemplateLanguage = fromLanguage
      // Editor: call save for get language html and content
      this.saveTemplate = {
        ts: moment().valueOf(),
        mode: 'copy',
        stayAfter: null,
        goToAfterSave: null
      }
    },
    copyTemplate () {
      this.translating = true
      var self = this
      setTimeout(function () {
        self.copyTemplateLanguage(self.copyingTemplateLanguage, 0, self.getTemplateReqObj('contentmetadata'))
        self.copyTemplateLanguage(self.copyingTemplateLanguage, 0, self.getTemplateReqObj('contenthtml'))
        self.copyingTemplateLanguage = null
      }, 500)
    },
    copyTemplateLanguage (fromLanguage, index, object) {
      if (index < object.languageValue.length) {
        var language = object.languageValue[index]
        if (language.key !== fromLanguage.key && language.value.trim() === '') {
          object = transport.methods.setLanguageValue(object, transport.methods.getLanguageValue(object, this.languageSelected.key), language.key)
        }
        this.copyTemplateLanguage(fromLanguage, ++index, object)
      } else {
        var self = this
        setTimeout(function () {
          self.translating = false
        }, 200)
      }
    },
    getDefinitionFieldClassTaskClass (reqDef) {
      var definition = this.visualDefinition.getDefinitionFields(reqDef)
      return definition.tasks
    },
    diagramSaved (xml, svg) {
      console.log(xml, svg)
    },
    getLang (key) {
      return language(this.language, key)
    },
    callSaveOrUpdate (stay) {
      // modify
      if (this.definitionContentId && this.type.actions.update) {
        this.callUpdate(stay, this.saveDefinitionTo)
      // create
      } else if (this.type.actions.create) {
        this.callCreate(stay, this.saveDefinitionTo)
      }
    },
    definitionCarouselAction (carouselAction) {
      if (carouselAction && (carouselAction.action === 'navigation' ||
        carouselAction.action === 'pagination') && carouselAction.actionData &&
        carouselAction.actionData.validation === false) {
        this.formErrors = 1
      } else {
        this.formErrors = 0
      }
      this.$emit('definitioncarouselaction', carouselAction)
    },
    refreshDefinitionContent () {
      this.getDefinitionContent(true)
    },
    setEmbeddedIdCode () {
      if (this.embeddedDefinition.id) {
        this.definitionContentId = this.embeddedDefinition.id
      }
      if (this.embeddedDefinition.code) {
        this.definitionContentCode = this.embeddedDefinition.code
      }
    },
    waitingProcessInit () {
      this.$emit('waitingProcessInit')
    },
    editingQuestion (editingQuestion) {
      this.isEditingQuestion = editingQuestion
    },
    getTypeActions () {
      let actionsCopy = JSON.parse(JSON.stringify(this.type.actions))
      if (transport.methods.allDefinitionReadable(this.definitionContent.requestDefinition)) {
        if (actionsCopy) {
          actionsCopy.create = null
          // actionsCopy.delete = null
          actionsCopy.update = null
        }
      }
      return actionsCopy
    },
    callSaveByFieldChange () {
      if (this.type.actions) {
        if (this.type.actions.create) {
          this.callCreate(true, null, this.type.actions.create.confirmText)
        } else if (this.type.actions.update) {
          this.callUpdate(true, null, this.type.actions.update.confirmText)
        }
      }
    },
    getDefinitionStyle () {
      let definition = this.visualDefinition.definition
      let result = ''

      if (definition && definition.formContainerStyle && definition.formContainerStyle !== '') {
        result = definition.formContainerStyle.replaceAll('->', ':')
      }

      return result
    }
  },
  computed: {
    isTypeWithActions () {
      return (this.type.actions && (this.type.actions.create || this.type.actions.delete || this.type.actions.update)) || this.actionButtonTasks.length > 0
    }
  },
  watch: {
    content (content) {
      this.resetMsgAndErrors()
      this.deactivateValidatingForm()
      this.getDefinitionContent()
    },
    saveDefinition (saveDefinition) {
      if (saveDefinition) {
        this.callSaveOrUpdate()
      }
    },
    builderModifyCall (builderModifyCall) {
      if (builderModifyCall) {
        this.setEmbeddedIdCode()
        this.callSaveOrUpdate(true)
      }
    },
    builderDeleteCall (builderDeleteCall) {
      if (builderDeleteCall) {
        this.setEmbeddedIdCode()
        this.callDelete(false)
      }
    },
    validateForm (validateForm) {
      // Carousel validation refresh
      if (this.isCarousel()) {
        var newCarouselValidateForm = []
        for (var i = 0; i < this.definitionContent.requestDefinition.length; i++) {
          newCarouselValidateForm.push({
            validating: true,
            timeEvent: moment().valueOf()
          })
        }
        this.carouselValidateForm = newCarouselValidateForm
      }
    },
    callCreateFromNew (value) {
      this.callCreate(false)
    }
  }
}
</script>

<style lang="scss">
.loadingDefinition {
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
}
#container_form_definition.open {
    overflow-y: auto;
    background-color: white !important;
}
#container_form_definition>div.searcher-padding {
    padding: 30px 0 10px;
}
#container_form_definition.open #icon_filter {
    color: #ff7643;
}
#form_definition {
  position: relative;
  overflow-y: initial !important;
  transition: max-height .6s ease-in;
}
#container_form_definition.open #form_definition {
  max-height: 0;
  transition: max-height .6s ease-out;
}
.definition-title {

  &.dotted {
    border-bottom: 1px dotted #4599a4;
  }

  .fieldsHeaderTitle {
    margin-bottom: 20px;
  }

  span:first-of-type{
    font-family: "Source Sans Pro", sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4599a4;
    padding-bottom: 7px;
    display: none;
    margin-bottom: 8px;

    i {
      margin-left: 15px;
      cursor: pointer;
    }
  }
}
#icon_filter {
  transition: transform .6s;
  z-index: 9999;
}
#container_form_definition.open #icon_filter {
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
#container_form_definition.definition {
  background: none !important;
}

.noPadding > .group {
  padding: 0 !important;
}
.noMargin > .group {
  margin: 0 !important;
}

.app-container {
  #container_form_definition {
    position: relative;
    width: 100%;
    padding-bottom: 250px;

    .definition-wrapper.group {
      width: 100%;
      min-height: 98px;
      margin: 0 0 10px;
      padding: 15px 0 15px 0;
      float: left;
      background-color: #f8f8f8;

      div.title {
        font-size: 19px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        display: inline-block;
        text-transform: uppercase;

        .labelText {
          margin-top: 0;
          margin-bottom: 0;
          display: inline-block;
          font-family: "Source Sans Pro", sans-serif;
          color: #8d8d8d;
          vertical-align: baseline;
          padding-left: 3px;

          i {
            margin-right: 5px;
            font-size: 19px;
            vertical-align: middle;

            &:before {
              font-weight: 100;
            }
          }
        }
      }

      ul {
        list-style: none;

        li span {
          font-size: 12px;
          font-family: "Noto Sans";
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
        }

        span:first-child.required {
          font-weight: bold;
        }
      }
    }
    .definition-wrapper .group.error_group_validate {
      border: 1px solid #cf0000;
    }
  }
  .pretty input:checked~.state.p-primary label:after,
  .pretty.p-toggle .state.p-primary label:after {
    background-color: #d42e12 !important;
  }
}

.template-html {
  padding: 0 50px 0 0 !important;
}
.template {
  .template-html {
    display: none;
  }
  .languageSelectorOrTask {
    position: absolute;
    left: 220px;
    top: 4px;
    z-index: 10;

    .translate {
      i:before {
        color: #d42e12;
      }
    }
  }
}
.mosaico-editor-container {
  #main-toolbox {
    #tooltabs.ui-tabs {
      text-align: center;

      .ui-tabs-nav {
        position: relative !important;
        display: inline-block;
        margin: 0 auto;
      }

      #toolblocks {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
    }
  }
  #toolbar {
    text-align: center;

    .leftButtons {
      float: none !important;
    }
    .rightButtons {
      display: none !important;
    }
  }
  #main-wysiwyg-area{
    replacedbody {
      max-width: none !important;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }

  #frame-container {
    box-shadow: none !important;
    background-color: transparent !important;

    > iframe {
      padding: 0 !important;
      border-radius: 6px !important;
    }
  }
}

.new-email-template,
.get-email-template,
.new-landing-template,
.get-landing-template,
.new-certificate-template,
.get-certificate-template,
.new-minutes-template,
.get-minutes-template,
.new-announcement-template,
.get-announcement-template,
.get-remember-template,
.get-hiring-template {
  #container_form_definition {
    height: 600px;

    .definition-wrapper {
      .group-elements {
        padding: 0;
      }
    }
  }
  .definitionObj.template {
    padding: 0 !important;
    position: fixed;
    left: 120px;
    right: 18px;
    bottom: 70px;
    top: 70px;
  }
  #page {
    right: 50px !important;
  }
  #quest_bloc_agrupacio-0-1 {
    min-height: 70px !important;

    > .group {
      background-color: transparent !important;
      padding: 0 !important;
      min-height: 70px !important;
      margin: 0 !important;

      #apptmpl_template_title,
      #apptmpl_template_organizationid,
      #apptmpl_template_structureid,
      #apptmpl_template_type {
        padding: 0 10px 0 0;
        min-height: 70px !important;

        label {
          font-size: 1.1em;
        }

        .multiselect {
          border: 0;

          .multiselect__content-wrapper {
            max-height: 500px !important;
            background-color: #333;
            border-radius: 0;
            border-left: 1.5px solid #fff;
            border-right: 1.5px solid #fff;
            border-bottom: 1.5px solid #fff;
            color: #fff;

            ul li span {
              font-size: 14px;
            }
          }
        }

        .apptmpl_template_title input,
        .multiselect__tags,
        .read-only {
          background-color: transparent;
          border-top: 0 !important;
          border-left: 0 !important;
          border-right: 0 !important;
          border-bottom: 1.5px solid #fff !important;
          color: #fff !important;
          border-radius: 0 !important;
          padding-left: 0 !important;
          padding-right: 0 !important;
          font-size: 20px !important;
          height: 40px !important;
          margin-top: 5px !important;
          outline: 0 !important;
          font-family: 'Noto Sans' !important;
          width: 100%;

          &:focus {
            border-top: 0 !important;
            border-left: 0 !important;
            border-right: 0 !important;
            border-color: #fff !important;
            box-shadow: none;
          }

          .multiselect__placeholder {
            padding: 0;
            font-size: 20px;
            color: #757575;
          }

          .multiselect__input {
            background-color: transparent;
            color: #fff !important;
            font-size: 20px !important;
            outline: 0 !important;
            font-family: 'Noto Sans' !important;
          }
        }

        .read-only {
          padding-top: 4.5px;
        }

        .multiselect__single {
          background-color: transparent;
          color: #fff !important;
          font-size: 20px !important;
          outline: 0 !important;
          font-family: 'Noto Sans' !important;
          padding-top: 3px;
          padding-left: 0;
        }

        .arrow {
          right: 0;
        }

        .count {
          color: #fff;
          display: none;
        }

        .validation_icon {
          display: none;
        }

        .label.error_validate {
          top: 44px;
          left: 1px;
        }
      }
    }
  }
}
.new-minutes-template,
.get-minutes-template,
.new-announcement-template,
.get-announcement-template,
.get-remember-template,
.get-hiring-template {
  .definitionObj.template {
    top: 10px;
  }
}
</style>

<style lang="scss" scoped>
.item {
  min-height: 90px;
}
</style>

<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 100000000;

  .tooltip-inner {
    background: #d42e12;
    color: white;
    border-radius: 9px;
    padding: 5px 15px 5px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #d42e12;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 6px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>
